<template>
  <div class="op-user-wrapper">

    <div class="custom-wrapper"
      v-if="hasRes('op_user_create')">
      <el-button
        type="danger"
        size="medium"
        @click="openUserEditor('create')"
        v-if="hasRes('op_user_create')">添加运维用户</el-button>
    </div>

    <custom-table
      :data="userList"
      v-if="hasRes('op_user_index')"
      @data-change="updateTableData" >

      <el-table-column
        prop="user_id"
        label="用户ID"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="username"
        label="用户名称"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              代理商列表：{{ getAgentDesc(scope.row.agent_list) }}
            </div>
            <span>
              {{ scope.row.username }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="role_id"
        label="用户角色"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ scope.row.role.name || '管理员' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="activate"
        label="是否为管理员"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_admin === 0 ? 'danger' : 'primary'"
            size="mini"
            disable-transitions>{{ scope.row.is_admin === 0 ? '否' : '是' }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        header-align="center"
        v-if="hasRes('op_user_update')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            v-if="hasRes('op_user_update')"
            @click="openUserEditor('update', scope.row)">修改</el-button>
          <el-button
            size="mini"
            type="danger"
            v-if="hasRes('op_user_update')"
            :disabled="scope.row.is_admin === 1"
            @click="onDeleteUserClick(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="userCount"
      v-if="hasRes('op_user_index')"
      @page-change="updateTableData" />

    <dialog-op-user-editor
      v-model="userEditorDialogVisible"
      :mode="userEditorMode"
      :user="userEditorModel"
      :role-list="roleList"
      :agent-list="agentList"
      @submit="onUserEditorSubmit" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'

import DialogOpUserEditor from '@/pages/op/acl/components/DialogOpUserEditor'

import { mapState, mapGetters, mapMutations } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

import aclApi from '@/api/aclApi'
import agentApi from '@/api/agentApi'

import { md5 } from '@/utils/crypto'

export default {
  name: 'OpUser',
  components: {
    CustomTable,
    CustomPaginate,
    DialogOpUserEditor
  },
  data () {
    return {
      userList: [],
      userCount: 0,

      userEditorDialogVisible: false,
      userEditorMode: 'edit',
      userEditorModel: {},

      roleList: [],
      agentList: []
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    getAgentDesc (agentList) {
      if (agentList.length <= 0) {
        return '无'
      }

      const list = []
      for (const agent of agentList) {
        list.push(agent.agentname)
      }
      return list.join('，')
    },

    openUserEditor (mode = 'create', role = {}) {
      if (mode === 'update') {
        this.userEditorModel = role
      }
      this.userEditorMode = mode
      this.userEditorDialogVisible = true
    },
    onUserEditorSubmit (form) {
      form.password = md5(form.password)
      if (this.userEditorMode === 'create') {
        this.addUser(form)
      } else {
        form.userId = this.userEditorModel.user_id
        this.updateUser(form)
      }
    },
    async addUser (form) {
      try {
        const { rcode, msg } = await aclApi.addOpUser(form)
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: '添加运维用户成功'
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '添加运维用户失败'
        })
      }
    },
    async updateUser (form) {
      try {
        const { rcode, msg } = await aclApi.updateOpUser(form)
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: '更新运维用户成功'
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '更新运维用户失败'
        })
      }
    },
    async onDeleteUserClick (user) {
      try {
        await this.$confirm('此操作将永远删除用户', '是否继续', '删除用户', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const { rcode, msg } = await aclApi.delOpUser({
          userId: user.user_id
        })
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: '删除用户成功'
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
      }
    },

    async updateTableData () {
      this.loading = true

      try {
        const { rcode, msg, data } = await aclApi.getOpUsers({
          page: this.page,
          pageSize: this.pageSize,
          sort: this.sort
        })
        this.setLoading(false)

        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }

        this.userList = data.list
        this.userCount = data.count
      } catch (err) {
        console.log(err)
        this.setLoading(false)
        this.$message({
          type: 'error',
          message: '获取运维用户列表失败'
        })
      }
    },

    async getRoleList () {
      try {
        const { rcode, msg, data } = await aclApi.getOpRoles({
          page: 1,
          pageSize: 9999
        })
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }

        this.roleList = data.list
      } catch (err) {
        console.log(err)
        this.loading = false

        this.$message({
          type: 'error',
          message: '获取角色列表失败'
        })
      }
    },
    async getAgentList () {
      try {
        const { rcode, msg, data } = await agentApi.getAgents(1, 9999)
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }

        this.agentList = data.agents
      } catch (err) {
        console.log(err)
        this.loading = false

        this.$message({
          type: 'error',
          message: '获取代理商列表失败'
        })
      }
    }
  },
  mounted () {
    this.getRoleList()
    this.getAgentList()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";

.op-user-wrapper {

}
</style>



// WEBPACK FOOTER //
// src/pages/op/acl/OpUser.vue